/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
// styles
import injectSheet from 'react-jss'
import styles from './preview_styles'
import Space from 'material/space/space';
import PreviewConfig from 'material/previewconfig/previewconfig';
import ArticleCard from 'material/articlecard/articleccard';
import { ReactComponent as LeftArrow } from 'assets/icons/left-arrow.svg'
import { ReactComponent as RightArrow } from 'assets/icons/right-arrow.svg'
import AdPlacement from 'material/adplacement/adplacement';


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: GENERAL SECTION : MEDIA COMMENTS ~~~~~~~~~~ ========== */
const Preview = injectSheet(styles)((props) => {

  const {  
    showBeforeUnit,
    showOnFirstSlot,
    showInBetweenArticles,
    adsCountBetweenArticles,
    loadMoreStyle,
    enableSpotlight,
    showAfterUnit, 
    visibility,
    version,
  } = props

  const showAds = visibility !== 'NONE'

  return (
    <Space justifyContent={'flex-end'} klass={`preview ${props.classes.preview}`} >
    <PreviewConfig klass={`${version} showfirstslot-${showOnFirstSlot} enablespotlight-${enableSpotlight}`} >
        <Space gap={12} klass={'adsconfigpreview'} direction={'column'} alignItems={'center'} justifyContent={'center'}>
          { showBeforeUnit && showAds && <AdPlacement />}

          {/* Header */}
          <h3>Popular in the community</h3>

          {/* Article spotlight */}
          {enableSpotlight && (
            <Space klass={'firstslot'} direction={version === 'desktop' ? 'row' : (showBeforeUnit && loadMoreStyle === 'HORIZONTAL_SCROLL' ?  'column-reverse' : 'column')}>
              {showOnFirstSlot && showAds && <AdPlacement />}
              <ArticleCard direction={'horizontal'} />
            </Space>
          )}

          <Space alignItems={'center'} direction={'column'} style={{maxWidth: '360px'}}>
            {/* MOBILE - Load more button, Show first slot and article spotlight off */}
            {showOnFirstSlot && !enableSpotlight && version === 'mobile' && showAds && <AdPlacement />}
            
            {/* DESKTOP - Load more button, show first slot and article spotlightoff */}
            {showOnFirstSlot && !enableSpotlight && loadMoreStyle === 'BUTTON' && version === 'desktop' && showAds  && (
              <Space klass={'afterrowcard'} alignItems={'center'} justifyContent={'space-between'}>
                <Space alignItems={'center'} justifyContent={'center'}>
                  <AdPlacement />
                </Space>
                {version === 'desktop' && <ArticleCard />}
              </Space>
            )}

            <Space alignItems={'center'} justifyContent={'center'} gap={8}>
              {/* DESKTOP - Horizontal scroll, show first slot and article spotlight off */}
              {showOnFirstSlot && !enableSpotlight && loadMoreStyle === 'HORIZONTAL_SCROLL' && version === 'desktop' && showAds && <AdPlacement />}
              <div className='arrowwrap'>{loadMoreStyle === 'HORIZONTAL_SCROLL' && <LeftArrow width={30} height={30} className='leftarrow' />}</div>
                <div className='container'>
                  {/* Grid cards */}
                  {Array(showInBetweenArticles && loadMoreStyle === 'BUTTON' ? (showOnFirstSlot && !enableSpotlight && version === 'desktop' ? adsCountBetweenArticles - 1 : adsCountBetweenArticles) : 1).fill(0).map((i, index) => (
                      <>
                        {Array(version === 'desktop' ? (showOnFirstSlot && !enableSpotlight && loadMoreStyle === 'HORIZONTAL_SCROLL' ? 2 : 3) : 2).fill(0).map(() => (
                          <ArticleCard />
                        ))}
                      </>
                    ))}
                </div>
                <div className='arrowwrap'>{loadMoreStyle === 'HORIZONTAL_SCROLL' &&  <RightArrow width={30} height={30} className='rightarrow' />}</div>
            </Space>
            {/* Ads/article card - Load more button and after row enabled */}
            {showInBetweenArticles && loadMoreStyle === 'BUTTON' && showAds && (
              <Space klass={'afterrowcard'} alignItems={'center'} justifyContent={'space-between'}>
                <Space alignItems={'center'} justifyContent={'center'}>
                  <AdPlacement />
                </Space>
                {version === 'desktop' && <ArticleCard />}
              </Space>
            )}
          </Space>

          {/* Load more button */}
          {loadMoreStyle === 'BUTTON' && <div className='loadmorebutton'>Load more articles</div>}

          {showAfterUnit && showAds && <AdPlacement />}
        </Space>
      </PreviewConfig>
    </Space>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Preview;